import Svg from 'components/atoms/structure/Svg';
import React from 'react';
import { getSystemImageUrl } from 'utils/assets';

import { Container, ImageContainer } from './styles';

import InfoLogLevel from 'components/molecules/containers/InfoLogLevel';
import { getFallbackUrl } from '../../../../utils/general';
import PropTypes from 'prop-types';
import { LevelType } from 'types/data/level';
import { useSelector } from 'react-redux';

const Level3LevelModal = ({ level, levelConquered }) => {
    const auth = useSelector((state) => state.auth);
    const coursesCompleted = auth?.user?.coursesCompleted || [];
    const completedCourseIds = coursesCompleted.map((course) => course.id);
    const data = [
        {
            id: 91,
            active: completedCourseIds.includes(91) || levelConquered,
            title: 'Gestão e uso do tempo',
            url: getFallbackUrl('/aluno/cursos/curso/91', 'Perfil')
        },
        {
            id: 104,
            active: completedCourseIds.includes(104) || levelConquered,
            title: 'Vendas Consultivas',
            url: getFallbackUrl('/aluno/cursos/curso/104', 'Perfil')
        },
        {
            id: 98,
            active: completedCourseIds.includes(98) || levelConquered,
            title: 'Gestão de Riscos',
            url: getFallbackUrl('/aluno/cursos/curso/98', 'Perfil')
        },
        {
            id: 99,
            active: completedCourseIds.includes(99) || levelConquered,
            title: 'Sustentabilidade',
            url: getFallbackUrl('/aluno/cursos/curso/99', 'Perfil')
        },
        {
            id: 100,
            active: completedCourseIds.includes(100) || levelConquered,
            title: 'Governança',
            url: getFallbackUrl('/aluno/cursos/curso/100', 'Perfil')
        },
        {
            id: 106,
            active: completedCourseIds.includes(106) || levelConquered,
            title: 'Carreiras Administrativas do Agro',
            url: getFallbackUrl('/aluno/cursos/curso/106', 'Perfil')
        }
    ];
    return (
        <Container>
            <p>Desafio: </p>

            <h2>Conclua os cursos</h2>
            <span>Faça os cursos</span>

            <InfoLogLevel data={data} />
        </Container>
    );
};

Level3LevelModal.propTypes = {
    level: PropTypes.shape(LevelType),
    levelConquered: PropTypes.bool
};

export default Level3LevelModal;
